import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Responsive, Table} from 'semantic-ui-react';
import {CurrencyValue} from '../../../Common/Format';
import {ItemTypes} from 'helpers/constants';

const ItemsPanel = props => {
  const [isTablet, setIsTablet] = useState(false);

  const handleResponsiveUpdate = (e, {width}) => {
    setIsTablet(width <= Responsive.onlyTablet.minWidth);
  };

  return !props.items || !props.items.length ? null : (
    <Responsive fireOnMount onUpdate={handleResponsiveUpdate}>
      <Table compact>
        <Table.Header>
          <Table.Row columns="equal">
            <Table.HeaderCell width="1">Qty</Table.HeaderCell>
            <Table.HeaderCell width="4">Name</Table.HeaderCell>
            <Table.HeaderCell width="4">Description</Table.HeaderCell>
            {props.isEstimate && (
              <Table.HeaderCell width="1">Approved</Table.HeaderCell>
            )}
            <Table.HeaderCell>Rate</Table.HeaderCell>
            <Table.HeaderCell width="1">Tax</Table.HeaderCell>
            <Table.HeaderCell textAlign={isTablet ? 'left' : 'right'}>
              Amount
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {props.items.map(
            x =>
              (!x.groupName || !x.hideCurrentPricing) && (
                <Table.Row key={x.itemId}>
                  <Table.Cell width="1">
                    {x.priceListTypeId === ItemTypes.Group ? 1 : x.quantity}
                  </Table.Cell>
                  <Table.Cell width="4">
                    {x.groupName ? `${x.groupName} : ` : ''}
                    {x.qualifiedName || x.name}
                  </Table.Cell>
                  <Table.Cell width="4">{x.description}</Table.Cell>
                  {props.isEstimate && (
                    <Table.Cell
                      textAlign={isTablet ? 'left' : 'center'}
                      width="1"
                    >
                      {x.priceListTypeId === ItemTypes.Group
                        ? ''
                        : x.approved
                          ? 'Yes'
                          : 'No'}
                    </Table.Cell>
                  )}
                  <Table.Cell>
                    <CurrencyValue
                      value={
                        x.priceListTypeId === ItemTypes.Group ? '' : x.rate
                      }
                    />
                  </Table.Cell>
                  <Table.Cell width="1">{x.taxCode}</Table.Cell>
                  <Table.Cell textAlign={isTablet ? 'left' : 'right'}>
                    <CurrencyValue value={x.amount} />
                  </Table.Cell>
                </Table.Row>
              ),
          )}
        </Table.Body>
      </Table>
    </Responsive>
  );
};

ItemsPanel.defaultProps = {
  isEstimate: false,
  items: null,
};

ItemsPanel.propTypes = {
  items: PropTypes.array,
  isEstimate: PropTypes.bool,
};

export default ItemsPanel;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/ItemsPanel.js